export function numberWithCommas(x: number) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  // return x
}

export function removeCommas(x = '') {
  return x.replaceAll(',', '')
}